var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"status-dot",class:`status-dot--${_vm.status}`,style:(_vm.sizeStyle)})
}
var staticRenderFns = []

export { render, staticRenderFns }